import { TableCell, TableRow } from "@material-ui/core";
import {
	DatatablesFooterServerSide,
	Loading,
	TableAction,
} from "App/Component/ui";
import { getComparator, stableSort } from "App/Component/ui/datatable/utils";
import { useDatatables } from "App/hooks";
import { FreezeTable } from "components/organism";
import { headCellsKunjungan } from "./helpers";

export default function BundleKunjunganTable({
	rows,
	handleSelect,
	totalData,
	resetPagination,
	setNewData,
	pagination,
	onPrevious,
	onNext,
	handleClickPageNumber,
	handleChangeLimit,
	loading,
	handleChange,
	formFilter,
	setFormFilter,
}) {
	const { order, orderBy, handleRequestSort, length } = useDatatables({
		rows: rows,
		orderByDefault: "date",
		orderByRow: ["date", "id"],
	});

	return (
		<>
			<Loading show={loading} />

			<FreezeTable
				headCells={headCellsKunjungan}
				handleRequestSort={handleRequestSort}
				order={order}
				length={length}
				orderBy={orderBy}
			>
				{stableSort(rows, getComparator(order, orderBy)).map((row, index) => {
					return (
						<TableRow key={index}>
							<TableCell align="center">{index + 1}</TableCell>
							<TableCell align="center">
								<div
									style={{
										display: "flex",
										justifyContent: "center",
									}}
								>
									<TableAction
										isUpdate={false}
										isDelete={false}
										isSelect={true}
										clickSelect={() => handleSelect(row)}
									/>
								</div>
							</TableCell>
							<TableCell align="center">{row?.id_kunjungan}</TableCell>
							<TableCell align="center">{row?.nama_pasien}</TableCell>
							<TableCell align="center">{row?.no_rm}</TableCell>
							<TableCell align="center">{row?.instalasi}</TableCell>
							<TableCell align="center">{row?.nama_dokter}</TableCell>
							<TableCell align="center">{row?.dokter}</TableCell>
						</TableRow>
					);
				})}
				{rows.length === 0 && (
					<TableRow>
						<TableCell align="center" colSpan={headCellsKunjungan.length}>
							Tidak ada data
						</TableCell>
					</TableRow>
				)}
			</FreezeTable>

			<DatatablesFooterServerSide
				totalData={totalData}
				pagination={pagination}
				handleChangeLimit={handleChangeLimit}
				onPrevious={onPrevious}
				onNext={onNext}
				currentPage={pagination.page}
				handleClickPageNumber={handleClickPageNumber}
			/>
		</>
	);
}
